var _circle, _path, _path2, _rect, _rect2, _rect3, _line, _line2, _line3, _rect4, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8 L8 2 A6 6 0 0 1 14 8 Z",
    fill: "currentColor",
    opacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8 L14 8 A6 6 0 0 1 10 14 Z",
    fill: "currentColor",
    opacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 2,
    height: 6,
    fill: "currentColor",
    opacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 12,
    width: 2,
    height: 8,
    fill: "currentColor",
    opacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 10,
    width: 2,
    height: 10,
    fill: "currentColor",
    opacity: 0.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 16,
    x2: 24,
    y2: 16,
    stroke: "currentColor",
    strokeWidth: 0.5,
    opacity: 0.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 12,
    x2: 24,
    y2: 12,
    stroke: "currentColor",
    strokeWidth: 0.5,
    opacity: 0.3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 24,
    y2: 8,
    stroke: "currentColor",
    strokeWidth: 0.5,
    opacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16,
    width: 10,
    height: 6,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 18,
    x2: 10,
    y2: 18,
    stroke: "currentColor",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 20,
    x2: 10,
    y2: 20,
    stroke: "currentColor",
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 22,
    x2: 8,
    y2: 22,
    stroke: "currentColor",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.e2ab9308e7582e2b82aa6b59240ed1f1.svg";
export { ForwardRef as ReactComponent };